import React from "react";
import { connect } from "../../base/redux";
import { getFilmStyle } from "../functions";

import PinFilm from "./PinFilm";
import VadFilm from "./VadFilm";

function VadCoverFilm({
    minHeight
}) {
    return (
        <div className="voice" style={{ minHeight: `${minHeight}px` }}>
            <div className="cover">
                <div className="pin">
                    <div style={{ overflow: "hidden", display: "inline-flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center" }}>
                        <PinFilm onlyOne={false} isStyle={true} half={true} />
                    </div>
                </div>
                <div style={{width: "100%", height: "100%"}}>
                    <VadFilm half={true} />
                </div>
            </div>
        </div>
    )
}

function _mapStateToProps(state) {
    const { height } = getFilmStyle(state, 1, true);

    return {
        minHeight: height
    }
}

export default  connect(_mapStateToProps)(VadCoverFilm);